import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoadingOverlay } from '@warmancer/ui';
import { App } from './App';
import { useLoadingStore } from './stores/loadingStore';
import './styles/app.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

function GlobalLoading() {
  const { visible, message } = useLoadingStore();
  return (
    <LoadingOverlay
      visible={visible}
      message={message}
      timeout={10000}
      onTimeout={() => useLoadingStore.getState().hide()}
    />
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <GlobalLoading />
    </QueryClientProvider>
  </StrictMode>
);
